import { render } from "./StringsLayoutRow.vue?vue&type=template&id=773f0fa9"
import script from "./StringsLayoutRow.vue?vue&type=script&lang=js"
export * from "./StringsLayoutRow.vue?vue&type=script&lang=js"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__